import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { IStaffingStandardsTracon } from './staffing-standards-tracon-list';

import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class StaffingStandardsTraconService {

    //need to have this somewhere besides hardcoded in here
    //private _staffingStandardsTraconUrl = `http://localhost:55706/api/systemmanagement/SSTracon`;
    private _staffingStandardsTraconUrl = `api/systemmanagement/SSTracon`;
 
    constructor(private httpHelper: HttpHelper) { }

    getSSTracon(scenarioId: number): Observable<IStaffingStandardsTracon> {
         return this.httpHelper.get(`${this._staffingStandardsTraconUrl}/${scenarioId}`)
             //.map((response: Response) => <IStaffingStandardsTracon> response.json())
             //.do(data => console.log('IStaffingStandardsTracon: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/staffing-standards/staffing-standards-tracon/staffing-standards-tracon.service.ts
 **/